/**
 * Tela 2 — Nome do Local
 * Campo livre + chips de exemplos. Textos temáticos via getWelcomeText (síncrono).
 */

import { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, Chip } from '@mui/material';
import { getWelcomeText, getWelcomeList } from '../../../utils/welcomeText';
import { wlog } from '../../../utils/welcomeDebug';

export default function Step2Location({ wizard, goNext }) {
  const [location, setLocation] = useState(() => wizard.state?.locationName || '');

  const template = wizard.template;
  const firstName = wizard.state?.userName?.split(' ')[0]?.trim() || '';

  wlog('Step2Location', 'RENDER', { location, firstName, templateId: template?.id || 'NENHUM' });
  useEffect(() => {
    wlog('Step2Location', '🟢 MONTADO no DOM');
    return () => wlog('Step2Location', '🔴 DESMONTADO do DOM');
  }, []);

  // getWelcomeText / getWelcomeList são síncronos — sem estado de "loading".
  const titleText =
    getWelcomeText(template, 'locationTitle', { firstName }) ||
    'Qual o nome do seu local?';
  const hintText = getWelcomeText(template, 'locationHint', {});
  const examples = getWelcomeList(template, 'locationExamples') || [];

  const isFilled = location.trim().length > 0;

  const handleContinue = () => {
    if (!isFilled) return;
    wizard.setLocationName(location.trim());
    (goNext || wizard.goNext)();
  };

  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px 40px',
        minHeight: '100%',
      }}
    >
      <Box sx={{ maxWidth: '500px', width: '100%', textAlign: 'center' }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: 600, marginBottom: '16px', color: 'text.primary' }}
        >
          {titleText}
        </Typography>

        <TextField
          fullWidth
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder="Nome do seu local"
          variant="outlined"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && isFilled) handleContinue();
          }}
          sx={{
            marginBottom: '20px',
            '& .MuiOutlinedInput-root': { fontSize: '16px' },
          }}
        />

        {examples.length > 0 && (
          <Box sx={{ marginBottom: '24px' }}>
            <Typography
              sx={{ fontSize: '12px', color: 'text.secondary', marginBottom: '12px', fontWeight: 500 }}
            >
              Exemplos:
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
              {examples.slice(0, 4).map((example, idx) => (
                <Chip
                  key={idx}
                  label={example}
                  onClick={() => setLocation(example)}
                  variant="outlined"
                  sx={{ cursor: 'pointer' }}
                />
              ))}
            </Box>
          </Box>
        )}

        {hintText && (
          <Typography
            sx={{
              fontSize: '13px',
              color: 'text.secondary',
              marginBottom: '40px',
              lineHeight: 1.6,
            }}
          >
            {hintText}
          </Typography>
        )}

        <Button
          variant="contained"
          size="large"
          onClick={handleContinue}
          disabled={!isFilled}
          sx={{
            textTransform: 'none',
            fontSize: '16px',
            fontWeight: 600,
            paddingX: '48px',
            paddingY: '12px',
          }}
        >
          Continuar
        </Button>
      </Box>
    </Box>
  );
}
